import { PenLine, Plus } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import {
  NewShiftDialog,
  UpdateShiftDialog,
} from "@/components/dialog/staff-manage/shift-schedule-dialog";
import { useEffect } from "react";
import { getAllShift } from "@/api/new-api/shift/shift";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";

function ShiftSettingsTabs() {
  const [openNewShiftDialog, setOpenNewShiftDialog] = useState(false);
  const [openUpdateShiftDialog, setOpenUpdateShiftDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedShiftData, setSelectedShiftData] = useState(null);
  const [activeShiftType, setActiveShiftType] = useState("weekly");
  const [shifts, setShifts] = useState([]);

  const fetchAllShift = async () => {
    try {
      setLoading(true);
      const response = await getAllShift();
      if (response.status === "success") {
        setShifts(response?.data?.shift_schedules || []);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const filteredShifts = shifts?.filter(
    (shift) => shift.shift_type === activeShiftType
  );

  useEffect(() => {
    fetchAllShift();
  }, []);

  const onDialog = () => setOpenNewShiftDialog(true);
  const offDialog = () => setOpenNewShiftDialog(false);

  const onDialogUpdate = (day, shiftData) => {
    setSelectedDay(day);
    setSelectedShiftData(shiftData);
    setOpenUpdateShiftDialog(true);
  };

  const offDialogUpdate = () => {
    setSelectedDay(null);
    setSelectedShiftData(null);
    setOpenUpdateShiftDialog(false);
  };

  if (loading) return <OnlyTableSekeleton header={false} />;
  return (
    <TabsContent className="container" value="shift-settings">
      <div className="flex items-center justify-between mt-5">
        <div className="h-10 px-0.5 bg-cblack3 border border-gray-600 flex rounded justify-center items-center">
          <div
            onClick={() => setActiveShiftType("weekly")}
            className={`${
              activeShiftType === "weekly" ? "bg-cyellow" : "text-white"
            } px-3 py-1 rounded cursor-pointer `}
          >
            Weekly
          </div>
          <div
            onClick={() => setActiveShiftType("daily")}
            className={`${
              activeShiftType === "daily" ? "bg-cyellow" : "text-white"
            } px-3 py-1 rounded cursor-pointer`}
          >
            Daily
          </div>
        </div>
        <Button onClick={onDialog}>
          <Plus size={20} /> Add New Time
        </Button>
      </div>

      <div className="mt-5 text-white">
        <div className="grid grid-cols-5 bg-cblack2 gap-4 py-3 font-semibold px-4">
          <div>Days</div>
          <div className="col-span-3">Shift & Time</div>
          <div className="text-right">Action</div>
        </div>

        <div className="space-y-2">
          {filteredShifts?.length > 0 ? (
            filteredShifts.map((shiftData, index) => (
              <div
                key={index}
                className="grid grid-cols-5 gap-4 py-3 bg-cblack5 items-center px-4"
              >
                <div className="capitalize">{shiftData?.day}</div>
                <div className="col-span-3 flex flex-wrap gap-2">
                  {shiftData && shiftData?.shifts?.length > 0 ? (
                    shiftData.shifts.map((shift, sIndex) => (
                      <span
                        key={sIndex}
                        className="bg-cblack6 border border-gray-600 px-4 py-2 rounded-md text-sm"
                      >
                        {shift?.start_time} - {shift?.end_time}
                      </span>
                    ))
                  ) : (
                    <span className="text-sm text-gray-400">
                      No shift assigned
                    </span>
                  )}
                </div>
                <div className="text-right">
                  <button
                    onClick={() => onDialogUpdate(shiftData?.day, shiftData)}
                    className="text-yellow-400 hover:text-yellow-300"
                  >
                    <PenLine size={20} />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-gray-400 mt-4">
              No {activeShiftType === "weekly" ? "weekly" : "daily"} shift
              available
            </div>
          )}
        </div>
      </div>

      <NewShiftDialog
        openNewShiftDialog={openNewShiftDialog}
        setShifts={setShifts}
        offDialog={offDialog}
      />
      <UpdateShiftDialog
        openUpdateShiftDialog={openUpdateShiftDialog}
        offDialog={offDialogUpdate}
        selectedDay={selectedDay}
        setShifts={setShifts}
        shiftData={selectedShiftData}
      />
    </TabsContent>
  );
}

export default ShiftSettingsTabs;
